import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.7237 2.27366C12.2129 0.762946 9.7683 0.762946 8.25938 2.27366L6.52902 4.00402L7.43973 4.91473L9.17009 3.18438C10.1308 2.22366 11.7522 2.12188 12.8129 3.18438C13.8754 4.24688 13.7737 5.86652 12.8129 6.82723L11.0826 8.55759L11.9951 9.47009L13.7254 7.73973C15.2326 6.22902 15.2326 3.78438 13.7237 2.27366V2.27366ZM6.82902 12.8129C5.8683 13.7737 4.24688 13.8754 3.18616 12.8129C2.12366 11.7504 2.22545 10.1308 3.18616 9.17009L4.91652 7.43973L4.00402 6.52723L2.27366 8.25759C0.762946 9.76831 0.762946 12.2129 2.27366 13.7219C3.78438 15.2308 6.22902 15.2326 7.73795 13.7219L9.4683 11.9915L8.55759 11.0808L6.82902 12.8129V12.8129ZM3.50402 2.59509C3.47717 2.5685 3.44091 2.55359 3.40313 2.55359C3.36534 2.55359 3.32908 2.5685 3.30223 2.59509L2.59509 3.30223C2.5685 3.32908 2.55359 3.36534 2.55359 3.40313C2.55359 3.44091 2.5685 3.47717 2.59509 3.50402L12.4951 13.404C12.5504 13.4594 12.6415 13.4594 12.6969 13.404L13.404 12.6969C13.4594 12.6415 13.4594 12.5504 13.404 12.4951L3.50402 2.59509Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DisconnectIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "disconnect",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})